import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchDashboardCompanyStats } from "../../../api/company";
import { DashboardStatsDetailDialog } from "../../utils/DashboardStatsDetailDialog";
import { nameToIcon, nameToPath, translateNameToSubtitle, translateNameToTitle } from "../../utils/dashboardStatsUtils";

export const DashboardFollowup = () => {
  const { t } = useTranslation();
  const [state, setState] = useState({ loading: true, error: false, stats: [] });
  const [retry, setRetry] = useState(0);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, error: false, stats: [] });
    fetchDashboardCompanyStats().then((response) => {
      if (!Array.isArray(response?.data?.data)) throw new Error("Invalid dashboard response");
      if (!cancelled) setState({ loading: false, error: false, stats: response.data.data });
    }).catch(() => { if (!cancelled) setState({ loading: false, error: true, stats: [] }); });
    return () => { cancelled = true; };
  }, [retry]);
  if (!state.loading && !state.error && !state.stats.length) return null;
  return <section className="pd-card pd-stats">
    <div className="pd-stats-head"><h2 className="pd-eyebrow">{t("dashboardDesign.attention")}</h2>{state.stats.length > 0 && <button type="button" onClick={() => setDetailDialogOpen(true)}>{t("dashboardDesign.showAll")} →</button>}</div>
    {state.loading ? <p role="status">{t("dashboardDesign.loading")}</p> : state.error ? <div className="pd-load-error" role="alert">{t("dashboardDesign.statsError")} <button type="button" onClick={() => setRetry((v) => v + 1)}>{t("dashboardDesign.retry")}</button></div> : <div className="pd-stat-grid">
      {state.stats.map((stat) => {
        const Icon = nameToIcon(stat.name);
        return <Link className="pd-stat" key={stat.name} to={nameToPath(stat.name)} data-attention={stat.name.startsWith("DEVIATIONS_OPEN") && Number(stat.count) > 0}>
          <div className="pd-stat-top"><Icon aria-hidden="true" /><strong>{stat.count}</strong></div>
          <strong>{translateNameToTitle(stat.name, t)}</strong><span>{translateNameToSubtitle(stat.name, t)}</span>
        </Link>;
      })}
    </div>}
    <DashboardStatsDetailDialog open={detailDialogOpen} onClose={() => setDetailDialogOpen(false)} stats={state.stats} />
  </section>;
};
